import React from 'react';
import {BottomTabHeaderProps} from '@react-navigation/bottom-tabs';

import {AppRoutesNavigatorParamList} from '../../models/navigationTypes';
import {Stack, Tab} from '../navigators';

export enum StoreType {
  GiftCardStore = 'GiftCardStore',
  LiquorStore = 'LiquorStore',
}

export enum TargetStoreType {
  GiftCardStore = StoreType.GiftCardStore,
  LiquorStore = StoreType.LiquorStore,
  All = 'All',
}

export type RouteWithoutTargetStoreType = Omit<RouteSpec, 'targetStoreType'>;

export type RouteSpec = {
  // `keyof AppRoutesNavigatorParamList` instead of `AppRoute` to keep
  // React Navigation typings happy
  name: keyof AppRoutesNavigatorParamList;
  component: any; // FIX
  title?: string;
  icon?: (props: {
    focused: boolean;
    size: number;
    color: string;
  }) => React.ReactNode;
  showInTab: boolean;
  showInDrawer: boolean;
  requiresLogin?: boolean;
  requiresLogout?: boolean;
  params?: object | undefined;
  header?: (props: BottomTabHeaderProps) => React.ReactNode;
  initialParams?: AppRoutesNavigatorParamList[keyof AppRoutesNavigatorParamList];
  targetStoreType: TargetStoreType;
  drawerSortOrder?: number;
  listeners?:
    | React.ComponentProps<typeof Tab.Screen>['listeners']
    | React.ComponentProps<typeof Stack.Screen>['listeners'];
};
